import React, {useState} from 'react';
import {Dialog, DialogContent, Button, Typography, Stack, IconButton} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from 'axios';
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import CaseStatus from "../../enums/CaseStatus";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";

const RequestToRemoveObject = ({onFileAdded, onCaseStatusChange}) => {
    const [open, setOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [fileSizeError, setFileSizeError] = useState('');

    const handleOpenConfirmationModal = () => {
        setIsConfirmationModalOpen(true);
    };

    const handleCloseConfirmationModal = () => {
        setIsConfirmationModalOpen(false);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        resetFile();
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            if (selectedFile.size > 10 * 1024 * 1024) {
                setFileSizeError('ფაილი აღემატება 10 მბ-ს');
                return;
            } else {
                setFileSizeError('');
            }
            setFileName(selectedFile.name);
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setFile(reader.result.replace(/^data:.+;base64,/, ''));
            };
        }
    };


    const sendNotification = async (caseType) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddCaseNotificationRangeByCaseId`, {
                caseId: caseType,
                caseStatus: CaseStatus.Sent.id,
                action: CaseNotificationEnum.requestToRemoveCaseFromRegistery.id,
            });

        } catch (error) {
        }
    };

    const handleSubmit = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const caseID = urlParams.get('id');
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`;
        const data = {
            caseID: parseInt(caseID),
            name: "ობიექტის უწყებრივი რეესტრიდან ამოღება",
            ext: "pdf",
            mainInfo: "",
            additionalInfo: "",
            file: file,
            shared: true,
            blank: false,
            documentType: 0,
            internal: false,
            status: 3,
            decline: CaseFileDeclined.ExtendDaysDocumentActive,
            fileTypeId: 23,
            declinedInternalStatus: 0,
        };

        try {
            const requestData = {
                id: parseInt(caseID),
                requestToRemoveObjectFromObjectRegister: 1,
            };
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseRequestToRemoveObjectFromObjectRegister`, requestData);


            const response = await axios.post(apiUrl, data);
            resetFile();

            await sendNotification(caseID, response.data.resultId)


            handleClose();
            onCaseStatusChange();
            onFileAdded();
        } catch (error) {
        }
    };




    const handlePreview = () => {
        if (!file) return;
        const byteCharacters = atob(file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const fileBlob = new Blob([byteArray], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(fileBlob);
        window.open(fileURL, '_blank');
    };

    const resetFile = () => {
        setFile(null);
        setFileName('');
        document.getElementById('contained-button-file').value = '';
    };
    return (
        <div>
            <button className={"document-buttonn"} onClick={handleClickOpen}>
                ობიექტის უწყებრივი რეესტრიდან ამოღება
            </button>
            <Dialog style={{zIndex: 34}} fullWidth maxWidth="sm" open={open} onClose={handleClose}>
                <DialogContent>
                    <Stack direction="column" spacing={2}>
                        <input
                            accept="application/pdf"
                            style={{display: 'none'}}
                            id="contained-button-file"
                            type="file"
                            onChange={handleFileChange}
                        />

                        <label htmlFor="contained-button-file">
                            <Button fullWidth variant="contained" component="span">
                                ფაილის ატვირთვა (მაქს. 10mb.)
                            </Button>
                        </label>
                        {fileSizeError && (
                            <div>
                                <Typography variant="body1" color="error">
                                    {fileSizeError}!
                                </Typography>
                            </div>
                        )}
                        {fileName && (
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="body1">{fileName}</Typography>
                                <IconButton aria-label="preview" onClick={handlePreview}>
                                    <VisibilityIcon/>
                                </IconButton>
                                <IconButton aria-label="delete" onClick={resetFile}>
                                    <DeleteIcon/>
                                </IconButton>
                            </Stack>
                        )}
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleOpenConfirmationModal}
                            disabled={!file}
                        >
                            გაგზავნა
                        </Button>
                    </Stack>
                </DialogContent>
            </Dialog>
            <ConfirmationModal
                isOpen={isConfirmationModalOpen}
                onRequestClose={handleCloseConfirmationModal}
                onConfirm={handleSubmit}
            />
        </div>
    );
};

export default RequestToRemoveObject;
